export default {
  min: {
    title:
      'Toimitus sijaintiisi: Summa, joka vaaditaan tilauksen vähimmäismäärän saavuttamiseksi (välisumma pl. toimituskulut ja tippi)',
    description:
      'Valitettavasti et voi tilata vielä. {{name}} on asettanut tilauksen vähimmäismääräksi {{threshold}} (pl. toimituskulut)',
  },
  max: {
    title: 'Toimituksen enimmäistilausarvo saavutettu (yhteensä pl. toimituskulut)',
    description:
      'Tilauksesi on saavuttanut verkkotoimituksen enimmäisarvon {{threshold}}. Jos tilauksesi ylittää tämän summan, ota meihin suoraan yhteyttä, jotta voimme järjestää toimituksen puolestasi. Kiitos ymmärryksestäsi!',
  },
};
